import React from 'react';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import _ from 'lodash';
import { withAppContext } from '@ctsu/loader';
import { compose, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { bindLogger } from 'helpers/BindLogger';
import { saveVersions, cancelVersions } from 'actions/protocols/version';
import { openConfirmation } from 'helpers/Confirmation';
import { CanUserEditLocalVersions, CanUserDeleteLocalVersions } from 'appconstants/Permission';
import { ValidatorForm } from 'components/FormHelpers/FormInputs';
import { openSnackbar } from 'helpers/Notifier';
import { httpStatusEnum , TE } from 'appconstants';
import { GetFromCtxValue, GetUserFullName, useGetPathProtocol } from 'helpers';
import { IrbExemptSelector } from 'selectors';
import { EditVersions } from './EditLocalVersion';
import { VersionColumns } from '../gridcolumns';

let setEditingVerFlag;
const LocalVersion = props => {
  const {
    data,
    state,
    setState,
    localDates,
    deleteVersions,
    saveLocalVersions,
    pioInfo,
    isIrbExempt
  } = props;

  const onDelete = (row) => {
    deleteVersions(row.verId);
  }

  const saveVersion = () => {
    saveLocalVersions(state);
  };


  const RenderEditRow = (row, setEditing) => {
    if (_.isEmpty(state) && !_.isEqual(row, state)) {
      setState({ ...row });
    }

    setEditingVerFlag = (flg) => {
      setEditing(flg);
      setState({});
    };

    return (
      <EditVersions
        state={state || row}
        setEditing={setEditing}
        defaultRow={row}
        data={data}
        setState={setState}
        pioInfo={pioInfo}
        localDates={localDates}
        isIrbExempt={isIrbExempt}
      />
    );
  };
  return (
    <ValidatorForm onSubmit={saveVersion}>
      <GridTable
        tag={`${TE.ID}localversions${TE.TABLE}`}
        title="Local Version(s)"
        exportTitle={`Local Version(s)-${useGetPathProtocol()}-Versions`}
        id="localVersions"
        columns={VersionColumns}
        rows={data}
        editable
        editMode={CanUserEditLocalVersions()}
        deletable={CanUserDeleteLocalVersions()}
        user={GetUserFullName()}
        allowAddRow
        enableToolbar
        filterable
        sortable
        onDelete={onDelete}
        renderEditRow={RenderEditRow}
        rowEditable={() => true}
        rowDeletable={() => true}
        recordPerPage={10}
        toPdf={false}
      />
    </ValidatorForm>
  );
};

const withConnectState = connect(
  (state, ownProps) => ({
    isIrbExempt: IrbExemptSelector(state)
  }),
  dispatch => bindActionCreators(
    {
      onSaveVersions: saveVersions,
      onDeleteVersion: cancelVersions
    },
    dispatch
  )
);


const LocalVersions = compose(
  withAppContext,
  withConnectState,
  withState('state', 'setState', {}),
  withHandlers({
    saveLocalVersions: props => postBody => {
      const {
        onSaveVersions, context, protocolId
      } = props;
      const confirmSaveVer = () => {
        bindLogger(onSaveVersions, context)(protocolId, { ...postBody, prtId: protocolId })
          .subscribe(resp => {
            if (resp.status === httpStatusEnum.SUCCESS) {
              setEditingVerFlag(false);
              openSnackbar({
                message: GetFromCtxValue(context, 'PROTOCOL_VERSIONS_SUCCESS'),
                variant: 'success',
                name: 'versions'
              });
            }
          });
      };
      openConfirmation({
        message: GetFromCtxValue(context, 'PROTOCOL_VERSIONS_CONFIRM'),
        onAction: confirmSaveVer,
        name: 'versions'
      });
    },
    deleteVersions: props => verId => {
      const {
        onDeleteVersion, context, protocolId, setState
      } = props;
      const confirmDelVer = () => {
        bindLogger(onDeleteVersion, context)(protocolId, verId).subscribe(resp => {
          if (resp.status === httpStatusEnum.SUCCESS) {
            setState({});
            openSnackbar({
              message: GetFromCtxValue(context, 'CANCEL_LOCAL_VERSIONS_SUCCESS'),
              variant: 'success',
              name: 'local_versions'
            });
          }
        });
      };
      openConfirmation({
        message: GetFromCtxValue(context, 'CANCEL_LOCAL_VERSIONS_CONFIRM_TXT'),
        onAction: confirmDelVer,
        name: 'cancel_versions'
      });
    }
  })
)(LocalVersion);


export { LocalVersions };
